import { createConsumer, Consumer } from '@rails/actioncable';

let consumerInstance: Consumer | null = null;

export const getConsumer = (): Consumer => {
  if (!consumerInstance) {
    consumerInstance = createConsumer();
  }
  return consumerInstance;
};
